import { getBlogApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { BlogPostResponse, CreateBlogPostRequest, UpdateBlogPostRequest } from '@/core/generated/api';

/** Выполняет операции со статьями блога */
export const blogService = {
    /** Загружает список блогов */
    async getAll(): Promise<BlogPostResponse[]> {
        try {
            const response = await getBlogApi().apiV1BlogsGetAllGet();

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает блог по идентификатору */
    async getById(id: string): Promise<BlogPostResponse> {
        try {
            const response = await getBlogApi().getBlogById({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Создаёт блог */
    async create(data: CreateBlogPostRequest): Promise<BlogPostResponse> {
        try {
            const response = await getBlogApi().createBlog({ createBlogPostRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет блог */
    async update(id: string, data: UpdateBlogPostRequest): Promise<BlogPostResponse> {
        try {
            const response = await getBlogApi()
                .updateBlog({
                    id,
                    updateBlogPostRequest: data
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Деактивирует блог */
    async deactivate(id: string): Promise<void> {
        try {
            await getBlogApi().deleteBlog({ id });
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        }
    },
};
